// extracted by mini-css-extract-plugin
export default {"container":"bottom-banner-module__container___bJkXM","withPlayer":"bottom-banner-module__withPlayer___PV08J","withBorder":"bottom-banner-module__withBorder___vRqvw"};